import SatelliteControl from './SatelliteControl';

export default SatelliteControl;